<style lang="scss" scoped src="./style/index.scss"></style>
<template>
    <header id="header" class="header">
        <div class="header-inner">
            <span class="logo">
                <!-- <router-link to="/">
                    <i class="iconfont icon-geely_svg logo-icon"></i>
                </router-link> -->
                <a href="javascript:;"
                    class="header-inner__title"
                >
                    <img src="./images/logo1.png">
                    <!-- {{ $t(`i18n.${this.$store.state.appCloudHeaderStore.title}`) }} -->
                </a>
            </span>
            <div class="header-inner__right">
                <div class="other-box">
                    <router-link
                        class="header-right-item header-inner__right-language"
                        :class="{ active: lang === 'zh-CN'} "
                        :to="routeOfChinese">中文</router-link>
                    <router-link
                        class="header-right-item"
                        :class="{ active: lang === 'en'} "
                        :to="routeOfEnglish">English</router-link>
                </div>
            </div>
        </div>
        <div class="shadow"></div>
    </header>
</template>
<script>
import appCloudHeaderStore from './store';

export default {
  name: 'appCloudHeader',
  beforeCreate() {
    if (!this.$store.state.appCloudHeaderStore) {
      this.$store.registerModule('appCloudHeaderStore', appCloudHeaderStore);
    }
  },
  computed: {
    lang() {
      const html = document.documentElement;
      const lang = this.$route.query.lang
                || this.$store.state.language
                || html.getAttribute('lang')
                || 'zh-CN';

      html.setAttribute('lang', lang);
      this.$store.dispatch('updateLang', {
        lang,
        i18n: this.$i18n,
      });

      return lang;
    },
    routeOfChinese() {
      return {
        query: {
          ...this.$route.query,
          lang: 'zh-CN',
        },
      };
    },
    routeOfEnglish() {
      return {
        query: {
          ...this.$route.query,
          lang: 'en',
        },
      };
    },
  },
};

</script>
